<div mat-dialog-content>
    <div class="mat-dialog-content">
        <div class="head-confirm-modal-list">
            <div class="img-head">
                <img style="width: 5rem;" src="assets/images/exclamation-circle.png" />
            </div>
            <div class="title-modal">
                <h1>Alerta de inatividade!</h1>
            </div>
        </div>
        <div class="body-confirm-modal-list">
            <div class="row">
                <div class="col-12">
                    <span class="description">
                        Sua sessão será encerrada dentro de <b>60 segundos</b> por Inatividade. 
                        Caso exista algum atendimento em aberto ou alguma informação/configuração não salva, todos os dados até aqui preenchidos <b>serão perdidos</b>.
                    </span>
                </div>
            </div>
            <div class="remaining-time-content">
                <span class="time"><b>{{remainingTime}}</b></span>
                <span>segundos</span>
            </div>
        </div>
        <div class="footer-confirm-modal-list">
            <button mat-flat-button color="accent" class="btn-block" (click)="clickConfirm()" type="button">
                <span>Continuar logado</span>
            </button>
        </div>
    </div>
</div>